import { Fragment, memo, ReactElement, useEffect, useMemo } from 'react';
import ActiveStep from './active-step';
import { useFormikContext } from 'formik';
import { CertificationFormVM } from 'civil-status/view-models/document-birth-form';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { Checkbox, FormControlLabel, Grid, Paper } from '@mui/material';
import { CertificationStep } from 'civil-status/constants/certification-step';

interface FormDetailProps {
  step?: number;
  onBack: () => void;
  onNext: () => void;
}

const FormDetailComponent = ({ step, onBack, onNext }: FormDetailProps): ReactElement => {
  const formContext = useFormikContext<CertificationFormVM>();

  const { userProfile } = useUserProfile();

  const cashManagement = useMemo(() => {
    return userProfile?.datiLogin?.profile?.servizio?.gestioneCassa || '';
  }, [userProfile?.datiLogin?.profile?.servizio?.gestioneCassa]);

  const isDisabledCashManagement = useMemo(() => {
    return cashManagement !== 'S';
  }, [cashManagement]);

  const isDisabledStep = useMemo(() => {
    return step === CertificationStep.Search;
  }, [step]);

  useEffect(() => {
    if (isDisabledCashManagement) {
      // settare a false il check sameAsApplicant
      formContext.setValues({
        ...formContext.values,
        accountholder: {
          ...formContext.values.accountholder,
          sameAsApplicant: false,
        },
      } as CertificationFormVM);
    }
  }, [isDisabledCashManagement]);

  return (
    <Fragment>
      {step === CertificationStep.ApplicantAccountholder || step === CertificationStep.Search ? (
        <Paper elevation={3} className="pmi-px-3 pmi-pb-2">
          <Grid
            item
            xs={12}
            container
            spacing={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="flagInternal"
                    checked={formContext.values.flagInternal || false}
                    disabled={isDisabledCashManagement || isDisabledStep}
                    onChange={() => {
                      formContext.setValues({
                        ...formContext.values,
                        flagCarta: !formContext.values.flagInternal,
                        flagInternal: !formContext.values.flagInternal,
                        accountholder: {
                          reasonRelease: '',
                          fiscalCode: '',
                          surname: '',
                          withoutSurname: false,
                          name: '',
                          withoutName: false,
                          gender: '',
                          birthDate: null,
                          sameAsApplicant: formContext.values.flagInternal,
                        },
                        applicant: {
                          fiscalCode: '',
                          searchApplicant: false,
                          matricola: '',
                          surname: '',
                          withoutSurname: false,
                          name: '',
                          withoutName: false,
                          gender: '',
                          birthDate: null,
                          birthChoiceDate: undefined,
                          municipality: null,
                          municipalityDocument: null,
                          isForeign: false,
                          foreignState: null,
                          foreignMunicipality: null,
                          foreignStateDocument: '',
                          documentNumber: '',
                          documentIssuedDate: null,
                          isForeignDocument: false,
                          birthplace: '',
                          residence: '',
                          state: '',
                        },
                      } as CertificationFormVM);
                    }}
                    inputProps={{ 'aria-label': 'Certificato ad uso interno' }}
                  />
                }
                label="Certificato ad uso interno"
              />
            </Grid>
          </Grid>
        </Paper>
      ) : undefined}
      <ActiveStep step={step} onBack={onBack} onNext={onNext} />
    </Fragment>
  );
};

FormDetailComponent.displayName = 'Civil Status - Form component';

const FormDetail = memo(FormDetailComponent);

export default FormDetail;
